var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("This is an about page")]),_vm._v(" "+_vm._s(_vm.frames)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }